import styled, { css } from 'styled-components';

import media from '~/utils/media';
import checkboxStd from '~/components/styled/checkbox';

export const Wrap = styled.div`

`;

export const TopWrap = styled.div`
  position: relative;

  > div.youtube-wrap {
    width: 100%;
    height: 15.8%;
    text-align: center;
    position: absolute;
    top: 51.5%;

    > div {
      width: 100%;
      height: 100%;
    }

    iframe {
      width: 95%;
      height: 100%;
    }
  }
`;

export const AgreeWrap = styled.div`
  padding: 4%;
  background-color: #e6f0ff;
`;

export const LabelWrap = styled.div`
  & + & {
    margin-top: 4%;
  }
`;

export const Label = styled.label`
  display: inline-flex;
  align-items: center;
  width: 100%;
  
  ${media.pcLarge`
    font-size: 20px;
  `}

  ${media.tabletLarge`
    font-size: 20px;
  `}

  ${media.tabletSmall`
    font-size: 20px;
  `}

  ${media.mobileLarge`
    font-size: 14px;
  `}

  ${media.mobileMid`
    font-size: 14px;
  `}

  ${media.mobileSmall`
    font-size: 14px;
  `}

  font-weight: 700;
  color: #326cf9;
  letter-spacing: -1px;

  > svg {
    margin-left: 2%;

    ${({ isCheck }) => isCheck ? css`
      transform: rotate(-180deg);
      transition: transform 150ms ease;
    ` : css`
      transform: rotate(0deg);
      transition: transform 150ms ease;
    `}

    ${media.mobileSmall`
      width: 32px;
      height: 32px;
    `}

    ${media.pcLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletLarge`
      width: 32px;
      height: 32px;
    `}

    ${media.tabletSmall`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileLarge`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileMid`
      width: 20px;
      height: 20px;
    `}

    ${media.mobileSmall`
      width: 20px;
      height: 20px;
    `}
  }
`;

export const Checkbox = styled.input`
  ${checkboxStd};

  ${media.mobileSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.pcLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletLarge`
    width: 24px;
    height: 24px;
  `}

  ${media.tabletSmall`
    width: 24px;
    height: 24px;
  `}

  ${media.mobileLarge`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileMid`
    width: 20px;
    height: 20px;
  `}

  ${media.mobileSmall`
    width: 20px;
    height: 20px;
  `}

  margin-right: 2%;
`;

export const Ul = styled.ul`
  margin-top: 2%;

  > li {
    padding-left: 2%;

    ${media.pcLarge`
      font-size: 16px;
    `}

    ${media.tabletLarge`
      font-size: 16px;
    `}

    ${media.tabletSmall`
      font-size: 16px;
    `}

    ${media.mobileLarge`
      font-size: 12px;
    `}

    ${media.mobileMid`
      font-size: 12px;
    `}

    ${media.mobileSmall`
      font-size: 12px;
    `}

    ${media.pcLarge`
      line-height: 28px;
    `}

    ${media.tabletLarge`
      line-height: 28px;
    `}

    ${media.tabletSmall`
      line-height: 28px;
    `}

    ${media.mobileLarge`
      line-height: 20px;
    `}

    ${media.mobileMid`
      line-height: 20px;
    `}

    ${media.mobileSmall`
      line-height: 20px;
    `}

    color: #656565;
    letter-spacing: -1px;
  }
`;

export const BottomWrap = styled.div`
  position: relative;

  > img {
    width: 22%;
    cursor: pointer;
    position: absolute;

    &.cvs {
      top: 36%;
      left: 58%;
    }
    
    &.station {
      top: 37%;
      left: 18%;
    }
    
    &.mall {
      top: 50%;
      left: 32%;
    }
    
    &.forest {
      top: 25%;
      left: 35%;
    }
  }
`;

export const Overlay = styled.div`
  width: 100%;
  max-width: 640px;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  position: fixed;
  top: 0;
  
  > img {
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    cursor: pointer;
  }
`;
